module.exports = __webpack_public_path__ + "static/media/DataDedup.4e0cd833.png";